import type { Ref } from 'vue'

import { useLessonRoomStore } from '../store'
import { useClassroomChat } from '../chat.hook'

interface LessonRoomChatViewReturn {
  draft: Ref<string>
  toggleChat: () => void
  submitMessage: () => Promise<void>
}

export const useLessonRoomChatView = (): LessonRoomChatViewReturn => {
  const lessonRoomStore = useLessonRoomStore()
  const { sendMessage, toggleChat } = useClassroomChat()

  const draft = ref<string>('')
  const messagesEnd = useTemplateRef<HTMLDivElement>('messagesEnd')

  const scrollToBottom = async (): Promise<void> => {
    await nextTick()
    messagesEnd.value?.scrollIntoView()
  }

  const submitMessage = async (): Promise<void> => {
    const text = draft.value
    draft.value = ''
    await sendMessage(text)
    await scrollToBottom()
  }

  watch(() => lessonRoomStore.getChatMessages.length, scrollToBottom)
  watch(() => lessonRoomStore.isChatOpen, (open) => {
    if (open) scrollToBottom()
  })

  return {
    draft,
    toggleChat,
    submitMessage,
  }
}